export default {
  namespaced: true,
  state: {
    callType: "",
    car: "",
    isDialogOpen: false,
  },
  mutations: {
    SET_CALLTYPE: (state: any, payload: string) => {
      state.callType = payload
    },
    SET_CAR: (state: any, payload: boolean) => {
      state.car = payload
    },
    SET_ISDIALOG_OPEN: (state: any, payload: boolean) => {
      state.isDialogOpen = payload
    },
  },
  actions: {
    classify: ({ state }: any, payload: Array<string>) => {
      switch (state.callType) {
        case "direct":
          return payload[0]
        case "call":
          return payload[1]
        case "message":
          return payload[2]
        default:
          return payload[3]
      }
    },
  },
}
